import ClassConstructor from './constructor';
import { ICanDisable } from './disabled';

export interface IHasTabIndex {
  tabIndex: number;
}

type HasTabIndexCtor = ClassConstructor<IHasTabIndex>;

export default function mixinTabIndex<T extends ClassConstructor<ICanDisable>>(
  base: T,
): HasTabIndexCtor & T {
  return class extends base implements IHasTabIndex {
    private _tabIndex: number = 0;

    get tabIndex(): number {
      return this.disabled ? -1 : this._tabIndex;
    }
    set tabIndex(value: number) {
      this._tabIndex = value;
    }

    constructor(...args: any[]) {
      super(...args);
    }
  };
}